/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconTimes from '@telus-uds/palette-allium/build/rn/icons/Times'
import PaletteIconSearchBold from '@telus-uds/palette-allium/build/rn/icons/SearchBold'
const theme = {
  appearances: {
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true, inactive: null },
      tokens: { outerBorderWidth: 2 }
    },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#7c53a5',
        borderWidth: 3,
        mobileBorderWidth: 1,
        outerBorderWidth: 0
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#f4f4f7',
        color: '#676e73',
        placeholderColor: '#676e73'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#676e73',
    borderRadius: 32,
    borderWidth: 1,
    buttonsGap: 2,
    clearButtonIcon: PaletteIconTimes,
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    iconLeftColor: '#676e73',
    iconLeftSize: 20,
    lineHeight: 1.5,
    mobileBorderWidth: 1,
    outerBackgroundColor: 'transparent',
    outerBorderColor: '#e3e6e8',
    outerBorderRadius: 32,
    outerBorderWidth: 0,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 8,
    paddingTop: 12,
    placeholderColor: '#414547',
    submitButtonIcon: PaletteIconSearchBold
  }
}
export default theme
